import { Chip, ChipSize, ChipVariant, IconSize, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import type { MeterType } from "@next-platform/packages-ts-types";
import { useMemo } from "react";

import RulebookMeterIcon from "@/components/Rulebook/RulebookMeterIcon";
import Trans from "@/components/Trans/Trans";

type RulebookProfileMeterCardHeaderProps = {
  icon?: string;
  meterType: MeterType;
  color?: string;
  label: string;
  typeLine: string;
  isShown: boolean;
};

const RulebookProfileMeterCardHeader = ({ icon, meterType, color, label, typeLine, isShown }: RulebookProfileMeterCardHeaderProps) => {
  const iconStyle = useMemo(() => ({ color }), [color]);

  return (
    <div className="flex items-center gap-2.5" data-testid="RulebookProfile-MeterCardHeader">
      <span className="relative flex h-9 w-9 flex-none items-center justify-center overflow-hidden rounded-[10px]" style={iconStyle}>
        <span className="absolute inset-0 bg-current opacity-15" />
        <RulebookMeterIcon icon={icon} meterType={meterType} color={color} size={IconSize.SMALL} />
      </span>
      <div className="min-w-0 flex-1">
        <Text variant={TextVariants.LABEL_LARGE_BOLD} className="block truncate">
          {label}
        </Text>
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="block text-gray-11">
          {typeLine}
        </Text>
      </div>
      {isShown ? (
        <Chip size={ChipSize.SMALL} variant={ChipVariant.SOFT_NEUTRAL} iconStart={IconVariants.EYE}>
          <Trans i18nKey="rulebook:profile.meter.shown" />
        </Chip>
      ) : (
        <Chip size={ChipSize.SMALL} variant={ChipVariant.OUTLINED} iconStart={IconVariants.EYE_OFF}>
          <Trans i18nKey="rulebook:profile.meter.hidden" />
        </Chip>
      )}
    </div>
  );
};

export default RulebookProfileMeterCardHeader;
